module.exports = __webpack_public_path__ + "img/v1.8535a740.png";